import { FilterTag } from 'components/filtertags'
import { SimNaoEnum, simNaoEnumToBoolean } from 'components/form'
import {
  tipoAbastecimentoAguaEnumRecord,
  tipoDestinoLixoEnumRecord,
  tipoDomicilioEnumRecord,
  tipoEscoamentoSanitarioEnumRecord,
  tipoImovelEnumRecord,
  tipoMaterialParedeEnumRecord,
  tipoPosseTerraEnumRecord,
  tipoSituacaoMoradiaEnumRecord,
  tipoTratamentoAguaEnumRecord,
} from 'components/form/field/select/CondicoesMoradiaSelectFields/condicoes-moradia-model'
import { itemToString } from 'components/form/field/select/StatusCadastroSelectField'
import {
  TipoAbastecimentoAguaEnum,
  TipoDestinoLixoEnum,
  TipoDomicilioEnum,
  TipoEscoamentoSanitarioEnum,
  TipoImovelEnum,
  TipoLocalizacaoEnum,
  TipoMaterialParedeEnum,
  TipoPosseTerraEnum,
  TipoSituacaoMoradiaEnum,
  TipoTratamentoAguaEnum,
} from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { isObjectDeepEmpty } from 'util/object'
import { stringGrouper } from 'util/string/string-grouper'
import { AnimaisImovelFormModel } from 'view/cadastro-imovel/model-cadastroImovel'
import {
  StatusCadastroImovelEnum,
  tipoLocalizacaoRecord,
  VisualizacaoMicroareasFilterFormModel,
  VisualizacaoMicroareasFilterModel,
} from 'view/visualizacaoTerritorial/model'
import { getTiposAnimaisStringListCapitalized } from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

export function isMicroareasFiltrosDefault(values: VisualizacaoMicroareasFilterFormModel | undefined) {
  return isObjectDeepEmpty(values ?? {})
}

function getAtualizadoHaTag(isCadastroAtualizadoMenosDeUmAno: boolean | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(isCadastroAtualizadoMenosDeUmAno)) {
    return undefined
  }
  return ['Atualizado há', isCadastroAtualizadoMenosDeUmAno ? 'Menos de um ano' : 'Um ano ou mais']
}

function getUltimaVisitaHaTag(isImovelVisitadoMenosDeUmMes: boolean | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(isImovelVisitadoMenosDeUmMes)) {
    return undefined
  }
  return ['Última visita há', isImovelVisitadoMenosDeUmMes ? 'Menos de um mês' : 'Um mês ou mais']
}

function getStatusCadastroTag(statusCadastroImovel: StatusCadastroImovelEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(statusCadastroImovel)) {
    return undefined
  }
  return ['Status do cadastro', itemToString[statusCadastroImovel]]
}

function getMaterialPredominanteTag(tipoMaterialParede: TipoMaterialParedeEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoMaterialParede)) {
    return undefined
  }
  return ['Material predominante', tipoMaterialParedeEnumRecord[tipoMaterialParede]]
}

function getAbastecimentoAguaTag(tipoAbastecimentoAgua: TipoAbastecimentoAguaEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoAbastecimentoAgua)) {
    return undefined
  }
  return ['Abastecimento de água', tipoAbastecimentoAguaEnumRecord[tipoAbastecimentoAgua]]
}

function getAguaConsumoTag(tipoTratamentoAgua: TipoTratamentoAguaEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoTratamentoAgua)) {
    return undefined
  }
  return ['Água para consumo', tipoTratamentoAguaEnumRecord[tipoTratamentoAgua]]
}

function getPossuiInconsistenciaTag(possuiInconsistencia: SimNaoEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(possuiInconsistencia)) {
    return undefined
  }
  return ['Possui inconsistência', simNaoEnumToBoolean[possuiInconsistencia] ? 'Sim' : 'Não']
}

function getTipoImovelTag(tipoImovel: TipoImovelEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoImovel)) {
    return undefined
  }
  return ['Tipo de imóvel', tipoImovelEnumRecord[tipoImovel]]
}

function getDestinoLixoTag(tipoDestinoLixo: TipoDestinoLixoEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoDestinoLixo)) {
    return undefined
  }
  return ['Destino do lixo', tipoDestinoLixoEnumRecord[tipoDestinoLixo]]
}

function getLocalizacaoTag(tipoLocalizacao: TipoLocalizacaoEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoLocalizacao)) {
    return undefined
  }
  return ['Localização', tipoLocalizacaoRecord[tipoLocalizacao]]
}

function getEscoamentoSanitarioTag(
  tipoEscoamentoSanitario: TipoEscoamentoSanitarioEnum | undefined
): FilterTag | undefined {
  if (isUndefinedOrNull(tipoEscoamentoSanitario)) {
    return undefined
  }
  return ['Escoamento de banheiro', tipoEscoamentoSanitarioEnumRecord[tipoEscoamentoSanitario]]
}

function getTipoDomicilioTag(tipoDomicilio: TipoDomicilioEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoDomicilio)) {
    return undefined
  }
  return ['Tipo de domicílio', tipoDomicilioEnumRecord[tipoDomicilio]]
}

function getEnergiaEletricaTag(isEnergiaEletricaDisponivel: SimNaoEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(isEnergiaEletricaDisponivel)) {
    return undefined
  }
  return ['Possui energia elétrica', simNaoEnumToBoolean[isEnergiaEletricaDisponivel] ? 'Sim' : 'Não']
}

function getSituacaoMoradiaTag(tipoSituacaoMoradia: TipoSituacaoMoradiaEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoSituacaoMoradia)) {
    return undefined
  }
  return ['Situação da moradia', tipoSituacaoMoradiaEnumRecord[tipoSituacaoMoradia]]
}

function getPosseTerraTag(tipoPosseTerra: TipoPosseTerraEnum | undefined): FilterTag | undefined {
  if (isUndefinedOrNull(tipoPosseTerra)) {
    return undefined
  }
  return ['Posse da terra', tipoPosseTerraEnumRecord[tipoPosseTerra]]
}

function getAnimaisImovelFilterTags(animaisImovel: AnimaisImovelFormModel | undefined): FilterTag[] {
  if (isUndefinedOrNull(animaisImovel?.possuiAnimais)) {
    return []
  }

  const possuiAnimais = animaisImovel.possuiAnimais
  const tags: FilterTag[] = [['Possui animais', simNaoEnumToBoolean[possuiAnimais] ? 'Sim' : 'Não']]

  if (!possuiAnimais) {
    return tags
  }

  const stringTiposAnimaisImovel = getTiposAnimaisStringListCapitalized(animaisImovel)
  const stringifiedGroup = !isUndefinedOrNull(stringTiposAnimaisImovel) && stringGrouper(...stringTiposAnimaisImovel)

  if (stringifiedGroup) {
    tags.push(['Tipos de animais no domicílio', stringifiedGroup])
  }

  return tags
}

export function getMicroareasFilterTags(values: VisualizacaoMicroareasFilterModel | undefined): FilterTag[] {
  const filterTags = [
    getAtualizadoHaTag(values?.isCadastroAtualizadoMenosDeUmAno),
    getUltimaVisitaHaTag(values?.isImovelVisitadoMenosDeUmMes),
    getStatusCadastroTag(values?.statusCadastroImovel),
    getMaterialPredominanteTag(values?.condicoesMoradia?.tipoMaterialParede),
    getAbastecimentoAguaTag(values?.condicoesMoradia?.tipoAbastecimentoAgua),
    getAguaConsumoTag(values?.condicoesMoradia?.tipoTratamentoAgua),
    getPossuiInconsistenciaTag(values?.possuiInconsistencia),
    getTipoImovelTag(values?.tipoImovel),
    getDestinoLixoTag(values?.condicoesMoradia?.tipoDestinoLixo),
    getLocalizacaoTag(values?.condicoesMoradia?.tipoLocalizacao),
    getEscoamentoSanitarioTag(values?.condicoesMoradia?.tipoEscoamentoSanitario),
    getTipoDomicilioTag(values?.condicoesMoradia?.tipoDomicilio),
    getEnergiaEletricaTag(values?.condicoesMoradia?.isEnergiaEletricaDisponivel),
    getSituacaoMoradiaTag(values?.condicoesMoradia?.tipoSituacaoMoradia),
    getPosseTerraTag(values?.condicoesMoradia?.tipoPosseTerra),
  ].filter((tag): tag is FilterTag => !isUndefinedOrNull(tag))

  return [...filterTags, ...getAnimaisImovelFilterTags(values?.animaisImovel)]
}
